import routeMap from "~/routes/prova/routeMap";

const perfilVerify = ({ next, router, to, store }) => {
  try {
    if (store.state.usuario.perfis) {
      let perfisUsuario = store.state.usuario.perfis.map(p => p.tipoId);

      if (perfisUsuario) {
        let perfis;

        for (const group of routeMap) {
          if (group.routes) {
            for (const route of group.routes) {
              if (to.path.indexOf(route.path) > -1) {
                perfis = route.perfis;
                break;
              }
            }
          } else {
            if (to.path.indexOf(group.path) > -1) {
              perfis = group.perfis;
              break;
            }
          }
        }

        if (perfis) {
          for (const perfilUsuario of perfisUsuario) {
            if (perfis.includes(perfilUsuario)) {
              return next();
            }
          }
        }

        console.warn("Acesso negado! Perfil sem acesso");

        return router.push(`/prova/403`);
      }

      console.warn("Acesso negado! Sem perfis");

      return router.push(`/prova/403`);
    }
  } catch (erro) {
    console.log(erro);

    console.warn("Acesso negado!");

    return router.push(`/prova/403`);
  }
};

export default perfilVerify;



// WEBPACK FOOTER //
// ./src/middleware/perfilVerify.js